import React from "react";
import { Flex } from "theme-ui";

interface Props {
  background?: string;
  children: JSX.Element | JSX.Element[];
  alignCenter?: boolean;
  className?: string;
  variant: "full" | "right" | "left" | "top-right";
}

// [
//   "polygon(0 5%, 100% 0%, 100% 95%, 0 100%)",
//   null,
//   null,
//   null,
//   "polygon(0 10%, 100% 0%, 100% 90%, 0 100%)",
//   "polygon(0 15%, 100% 0%, 100% 85%, 0 100%)",
// ]

const SlantSection = ({
  background,
  children,
  alignCenter,
  className,
  variant,
}: Props) => {
  return (
    <section
      className={className}
      sx={{
        zIndex: 1,
        position: "relative",
        bg: background ? background : "white",
        clipPath:
          variant == "full"
            ? ["polygon(0 calc(5vw), 100% 0%, 100% calc(100% - 5vw), 0 100%)"]
            : variant == "right"
            ? "polygon(0 0, 100% 0%, 100% calc(100% - 5vw), 0 100%)"
            : variant == "top-right"
            ? "polygon(0 calc(5vw), 100% 0%, 100% 100%, 0 100%)"
            : [
                "polygon(0 0, 100% 0%, 100% 100%, 0% 95%)",
                null,
                null,
                null,
                "polygon(0 0, 100% 0%, 100% 100%, 0% 90%)",
                "polygon(0 0, 100% 0%, 100% 100%, 0% 85%)",
              ],
        display: "flex",
        justifyContent: alignCenter ? "center" : "flex-start",
        pt: variant == "full" || variant == "top-right" ? "8vw" : "0px",
        pb: variant == "full" || variant == "top-right" ? "6vw" : 0,
        mt:
          variant == "full" || variant == "top-right"
            ? ["-8vw", null, null, null, "-8vw", "-6vw"]
            : 0,
      }}
    >
      {children}
    </section>
  );
};

export default SlantSection;
